import { useCallback } from 'react'
import { TextInputLabelToolTip } from '../../../../../components/TextInputLabelToolTip'
import { dateFormatter, DateFormatTypes } from '../../../../../utils'

const getFormattedHistory = (changedHistory, fieldName) => {
  if (changedHistory?.[fieldName] && changedHistory?.[fieldName]?.length > 0) {
    const lastChangedHistory = changedHistory?.[fieldName]?.at(-1)
    if (lastChangedHistory?.oldValue) {
      return (
        'New Value : ' +
        lastChangedHistory?.newValue +
        '||' +
        'Old Value : ' +
        lastChangedHistory?.oldValue +
        '||' +
        'Updated  At : ' +
        dateFormatter(lastChangedHistory?.updatedAt, DateFormatTypes.DATE_AM_PM) +
        '||' +
        'Updated  By : ' +
        lastChangedHistory?.user?.username
      )
    }
  }
  return undefined
}

export const TextInputWithInfo = (props: any) => {
  const onTextChange = useCallback((text)=>{
    if(props?.textFormatType==='CAPITALIZED'){
      text= text?.toUpperCase()
    }
    props?.onChange(text)
  },[])
  return (
      <TextInputLabelToolTip
        {...props}
        value={!props?.editable && !props.value ? 'NA' : props.value}
        modalDetails={{ data: getFormattedHistory(props?.allValues?.changeHistory, props?.fieldName) }}
        error={props.editable ? props.error : undefined}
        onChange={onTextChange}       
      />
  )
}
